import * as userActions from '../redux/actions/userActions';

export const photosData = async (data, dispatchFn) => {
  let output = [];
  if (data?.id) {
    let file = await dispatchFn(userActions.getFile(data.id));
    output = [{ uid: data.id, name: data.filename_download, url: file }];
  }
  return output;
};

// export const setMultiPhotosData = async (data, fileName, dispatchFn) => {
//   const promises = data
//     .filter(item => !!item.directus_files_id)
//     .map(async (item, index) => ({
//       [`${fileName}-${index + 1}`]: [
//         {
//           name: item.directus_files_id.filename_download,
//           uid: item.directus_files_id.id,
//           url: await dispatchFn(userActions.getFile(item.directus_files_id.id)),
//         },
//       ],
//     }));
//   console.log(promises);
//   return Promise.all(promises);
// };
export const setMultiPhotosData = async (data, fileName, dispatchFn) => {
  const promises = data.map(async (item, index) => {
    const key = `${fileName}-${index + 1}`;
    if (item?.directus_files_id) {
      return {
        [key]: [
          {
            name: item.directus_files_id.filename_download,
            uid: item.directus_files_id.id,
            url: await dispatchFn(userActions.getFile(item.directus_files_id.id)),
            status: 'done',
          },
        ],
      };
    }
  });

  return Promise.all(promises);
};

export const basicPhotos = async (
  {
    print_only,
    print_only_small,
    thumbnail,
    print_and_mount_recto,
    mount_verso,
    signature_recto,
    signature_verso,
    annotations_verso,
    annotations_recto,
    stamp_verso,
    image_detail,
  },
  dispatchFn
) => {
  const promises = [
    photosData(print_only, dispatchFn),
    photosData(print_only_small, dispatchFn),
    photosData(thumbnail, dispatchFn),
    photosData(print_and_mount_recto, dispatchFn),
    photosData(mount_verso, dispatchFn),
    photosData(signature_recto, dispatchFn),
    photosData(signature_verso, dispatchFn),
    setMultiPhotosData(annotations_recto, 'annotations-recto', dispatchFn),
    setMultiPhotosData(annotations_verso, 'annotations-verso', dispatchFn),
    setMultiPhotosData(stamp_verso, 'stamp-verso', dispatchFn),
    setMultiPhotosData(image_detail, 'image-detail', dispatchFn),
  ];

  const [
    print_only_result,
    print_only_small_result,
    thumbnail_result,
    print_and_mount_recto_result,
    mount_verso_result,
    signature_recto_result,
    signature_verso_result,
    annotations_recto_result,
    annotations_verso_result,
    stamp_verso_result,
    image_detail_result,
  ] = await Promise.all(promises);
  return {
    print_only: print_only_result,
    print_only_small: print_only_small_result,
    thumbnail: thumbnail_result,
    print_and_mount_recto: print_and_mount_recto_result,
    mount_verso: mount_verso_result,
    signature_recto: signature_recto_result,
    signature_verso: signature_verso_result,
    annotations_recto: annotations_recto_result,
    annotations_verso: annotations_verso_result,
    stamp_verso: stamp_verso_result,
    image_detail: image_detail_result,
  };
};
export const setFormData = (data, defaultStamp = null, defaultStampSubGroup = null) => {
  return data.map((item, index) => {
    const { id, basic_photos_id, directus_files_id, stamp, notes, annotation_material, hand_writing_notes, stamp_subgroup } = item;

    return {
      id,
      notes,
      stamp: stamp || (index === 0 ? defaultStamp : null),
      directus_files_id: directus_files_id?.id,
      basic_photos_id,
      annotation_material,
      hand_writing_notes,
      stamp_subgroup: stamp_subgroup || (index === 0 ? defaultStampSubGroup : null),
    };
  });
};
